import { AssetUrlProps } from '@cld/code-snippet-next';

/**
 * Verify if given transformation URL should be opened in Transformation Builder
 * @see {@link shouldOpenTransformationBuilder.test.ts} for all use-cases
 */
export const shouldOpenTransformationBuilder = (parsedUrl: AssetUrlProps | undefined): parsedUrl is AssetUrlProps => {
  if (parsedUrl === undefined) {
    return false;
  }

  if (Object.keys(parsedUrl).length === 0) {
    return false;
  }

  if ('kind' in parsedUrl) {
    return !String(parsedUrl.kind).includes('video');
  }

  return true;
};
